import { AddressChoiceAction, AddressChoiceNavigator } from '@/setting/stores/addressChoice/address-choice-navigator';
import { BfPageStoreProvider, useIntentFinish, useStoreState } from '@tw/tw-runtime-react';
import React, { useState } from 'react';
import { ScrollView, TouchableOpacity } from 'react-native-gesture-handler';
import { Text, View } from 'react-native';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import {
  TwButton,
  TwColumn,
  TwIcon,
  TwListItem,
  TwListItemContent,
  TwPage,
  TwRadio,
  TwRow
} from '@tw/tw-components-rn';

import { BfAppContext } from '@tw/tw-runtime';
import { ElementUtils } from '@tw/tw-platform-react';
import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { ResAddressDTO } from '@tw/clvip-api-gen';
import { SettingAddressChoiceStore } from '../../stores/addressChoice/setting-addressChoice-store';
import { styles } from './styles';
import { useFocusEffect } from '@react-navigation/native';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';

export const SettingAddressChoice = (props) => {
  const [store] = useState(() => new SettingAddressChoiceStore());
  usePageStoreLifecycle(store, undefined);
  const data = useStoreState(store, (state) => state.data);

  console.log('SettingAddressChoice', data);

  const { setResultBack } = useIntentFinish(AddressChoiceNavigator);

  useFocusEffect(
    React.useCallback(() => {
      store.fetchListData();
      return;
    }, [store])
  );

  // 点击选择地址
  const isSelectAddressAction = AddressChoiceNavigator.getIntent()?.action === AddressChoiceAction.selectAddress;
  const selectedAddressId = AddressChoiceNavigator.getIntent()?.selectedAddressId;

  const onListItemClick = (item: ResAddressDTO) => {
    if (isSelectAddressAction) {
      setResultBack(item);
    }
  };

  return (
    <BfPageStoreProvider store={store}>
      <TwPage
        translucentStatusBar={true}
        footer={
          <View style={styles.commandContainer}>
            <TwButton
              style={styles.button}
              onPress={() => {
                BfAppContext.getInstance()
                  .getRouteService()
                  .push({
                    path: ROUTE_NAMES.SettingCreateAddress,
                    query: {
                      mode: 'create'
                    }
                  });
              }}
              shape={'round'}
            >
              新增收货地址
            </TwButton>
          </View>
        }
      >
        <TwPage.Header title={'选择地址'}></TwPage.Header>
        <ScrollView style={styles.container}>
          <TwColumn space={2}>
            {data?.map((item: ResAddressDTO, index) => {
              return (
                <TwListItem
                  pressable={isSelectAddressAction}
                  onPress={() => onListItemClick(item)}
                  key={index}
                  icon={
                    isSelectAddressAction ? (
                      <TwRadio
                        checked={item?.id === selectedAddressId}
                        onChange={() => {
                          onListItemClick(item);
                        }}
                      ></TwRadio>
                    ) : null
                  }
                  content={
                    <TwListItemContent
                      title={ElementUtils.getText(item, { type: 'coordinates', id: 'address' })}
                      // subTitle={}
                      content={
                        <TwRow space={2} alignItems={'center'} flexWrap={'wrap'}>
                          <Text style={styles.contentDesc}>{item?.linkmanName}</Text>
                          <Text style={styles.contentDesc}>{item?.linkmanMobile}</Text>
                          {item?.isDef ? <Text style={styles.contentTitle}>默认</Text> : null}
                        </TwRow>
                      }
                    />
                  }
                  rightContent={
                    <TouchableOpacity
                      onPress={() => {
                        BfAppContext.getInstance()
                          .getRouteService()
                          .push({
                            path: ROUTE_NAMES.SettingCreateAddress,
                            query: {
                              mode: 'edit',
                              addressId: item.id
                            }
                          });
                      }}
                    >
                      <TwIcon icon={'icon-create'} color={'#A4A4A4'} size={20}></TwIcon>
                    </TouchableOpacity>
                  }
                ></TwListItem>
              );
            })}
          </TwColumn>
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
